import { useGlobalStore } from '@highlight/ipc/react'
import { useLdFlag } from './useLdFlag'

type AgenticChatFlag = 'never' | 'user_controlled' | 'always'

export const useAgenticChatFlag = () => {
  return useLdFlag<AgenticChatFlag>('use-agentic-chat', 'never')
}

export const useIsAgenticChatEnabled = () => {
  const flag = useAgenticChatFlag()
  const [settingEnabled] = useGlobalStore<boolean>('settings', 'agentic-chat', false)

  if (flag === 'always') return true
  if (flag === 'user_controlled') return settingEnabled
  return false
}
